import { RRHeaderTabOptionModel } from './header-tab-option.model';

export class RRHeaderTabModel {
  name: string;
  show: boolean;
  options?: RRHeaderTabOptionModel[];
  link?: string;
}
